module.exports = __webpack_public_path__ + "static/media/secureframe-icon.cdcc742c.svg";